import React from 'react';
import {
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Box,
  Button,
} from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LoginIcon from '@mui/icons-material/Login';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import {
  setLoginStatus,
  setUserDetails,
  setUserId,
} from '../../redux/authSlice';

function AdminNavbar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.auth.userDetails);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    console.log('Logged out');
    dispatch(setLoginStatus(false));
    dispatch(setUserDetails({}));
    dispatch(setUserId(''));
    navigate('/loginadmin');
    handleMenuClose();
  };

  const handleLogin = () => {
    console.log('Login clicked');
    navigate('/loginadmin');
  };
  return (
    <div className='bg-amber-500 h-[65px] w-full'>
      <Toolbar className='flex justify-between items-center px-4 h-full text-white'>
        {/* Title */}
        <Box
          className='flex-grow'
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Typography
            variant='h6'
            sx={{ fontSize: '20px', color: 'white' }}
          >
            Welcome To Pralhad Flours Admin Panel
          </Typography>
        </Box>

        {/* Login Button */}
        {/* <Button
          variant='contained'
          color='primary'
          startIcon={<LoginIcon />}
          onClick={handleLogin}
          sx={{
            marginRight: '16px',
            backgroundColor: 'white',
            color: '#f59e0b',
            '&:hover': {
              backgroundColor: '#f3f4f6',
            },
          }}
        >
          Login
        </Button> */}

        {/* User Icon */}
        <IconButton color='inherit' onClick={handleMenuOpen}>
          <AccountCircleIcon />
        </IconButton>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem disabled>{userDetails?.email}</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </div>
  );
}

export default AdminNavbar;
